import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { TYPES } from '../../constants/gender';

const { Option } = Select;

const GenderType = () => {
    const { t } = useTranslation('forms', { keyPrefix: 'FORMS.INPUTS' });
    const { t: tr } = useTranslation('forms', { keyPrefix: 'FORMS.RULES' });

    const RULES = [{ required: true, message: tr('REQUIRED_FIELD') }];

    return (
        <Form.Item
            label={t('GENDER')}
            name="gender"
            initialValue="HIDDEN"
            rules={RULES}
        >
            <Select
                placeholder={t('GENDER')}
            >
                {
                    TYPES.map((type, index) => (
                        <Option value={type} key={index}>
                            {t(`GENDER_TYPES.${type}`)}
                        </Option>
                    ))
                }
            </Select>
        </Form.Item>
    );
};

export default GenderType;
